import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "./useAppContext";

export function useIsDarkForced() {
	const { platform, reactQueryNoReloadOptions } = useAppContext();

	return useQuery(["is-dark-forced"], () => platform.colorScheme.getIsDarkForcedAsync(), {
		...reactQueryNoReloadOptions,
		retry: false,
	});
}
